import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, CircularProgress, Button, Table, TableHead,
  TableRow, TableCell, TableBody, Stack,Tooltip,FormControl,InputLabel,Select,MenuItem,FormLabel,RadioGroup,FormControlLabel,Radio
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import { useOrderDetails,useUpdateOrder } from './orders.hooks';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { constants } from '../../constants';
import {convertGMTToLocal} from '../../common';
import { useQueryClient } from '@tanstack/react-query';
function OrderDetailsPopup({ orderid, open, onClose }) {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();
  const { data, isLoading } = useOrderDetails(orderid, open, (error) => {
      dispatch(showAlert({
        severity: 'error',
      title: error?.message || 'Failed to load order details.',
      }));
  });

  const order = data?.order;
  const [copied, setCopied] = React.useState(false);

  const [updateFlag, setUpdateFlag] = React.useState(false);
  const [paymentmode, setPaymentmode] = React.useState('');
  const [orderId, setOrderId] = React.useState('');
  const [paymentstatus, setPaymentstatus] = React.useState('');
  React.useEffect(() => {
    if (order) {
      setPaymentmode(order.paymentmode);
      setPaymentstatus(order.paymentstatus);
      setOrderId(order.order_id);
    }
  }, [order]);
  const handleCopy = async (orderId,orderHashedValue) => {
  
  const downloadUrl = `${constants.API_BASE}/vanorder/download-bill/${orderId}/${orderHashedValue}`;
  
    try {
      await navigator.clipboard.writeText(downloadUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // reset after 1.5 seconds
      dispatch(
        showAlert({
          severity: 'success',
          title: 'Successfully copied the link.',
        })
      );
    } catch (err) {
      dispatch(
        showAlert({
          severity: 'error',
          title: 'Failed to copy',
        })
      );
    }
  };
  const { mutate: updateOrderFn, isPending } = useUpdateOrder({
    onSuccess: () => {
      dispatch(showAlert({ severity: 'success', title: 'Order updated successfully!' }));
      queryClient.invalidateQueries(['orders']);
    },
    onError: (error) => {
      dispatch(
        showAlert({
          severity: 'error',
          title:
            error?.response?.data?.message ||
            error.message ||
            'Failed to update order.',
        })
      );
    }
  });
const updateOrder=()=>{
updateOrderFn({
  orderId: orderId,
  paymentmode,
  paymentstatus
});
}
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Order #{orderid} Details</DialogTitle>

      <DialogContent dividers>
        {isLoading ? (
          <CircularProgress />
        ) : !order ? (
          <Typography>No order data found.</Typography>
        ) : (
          <>
            <Stack spacing={1} mb={2}>
  {[
    { label: 'Date & Time', value: convertGMTToLocal(order.created_at) },
    { label: 'Load Id', value: order.loadid },
    { label: 'Van', value: order.vanname },
    
    { label: 'Customer', value: `${order.customername} (${order.customerphonenumber})` },
    { label: 'Email', value: order.customeremail || 'N/A' },
    { label: 'Subtotal', value: `€ ${order.orderprice}` },
    { label: 'Coupon Savings', value: order.coupon_discount_amount && order.coupon_code
      ? `€ ${order.coupon_discount_amount} [${order.coupon_code}]`
      : 'N/A' },
    { label: 'Discount', value: `€ ${order.discountamount}` },
    {
      label: 'Net Payable',
      value: `€ ${(
        order.orderprice 
        - (order.discountamount || 0) 
        - ((order.coupon_discount_amount && order.coupon_discount_amount > 0) 
            ? order.coupon_discount_amount 
            : 0)
      ).toFixed(2)}`
    },
    { label: 'Payment Mode',value:
      (constants.PAYMENT_MODE.CASH == order.paymentmode)?'Cash':
      (constants.PAYMENT_MODE.BANKTRANSFER == order.paymentmode)?'Bank Transfer':
      (constants.PAYMENT_MODE.CARD == order.paymentmode)?'Card':
      (constants.PAYMENT_MODE.PAYPAL == order.paymentmode)?'Paypal':'-NA-'

    },
    { label: 'Payment Status',value:  (constants.PAYMENT_STATUS.PAID == order.paymentstatus)?'Paid':'Pending'}
  ].map((item, index) => (
    <Stack key={index} direction="row" spacing={2}>
      <Typography sx={{ fontWeight: 'bold', minWidth: 140 }}>
        {item.label}:
      </Typography>
      <Typography>{item.value}</Typography>
            </Stack>
  ))}

<Stack  direction="row" spacing={2}>
      <Typography sx={{ fontWeight: 'bold', minWidth: 140 }}>
        {'Payment'}:
      </Typography>

      <FormControl  variant="outlined" size="small"  sx={{ minWidth: 150 }}>
          <InputLabel id="paymentmode-label">Payment Mode</InputLabel>
        <Select
      labelId="paymentmode-label"
      id="paymentmode"
      value={paymentmode || ''}
    size='small'
      onChange={(e) =>
        {
          setPaymentmode(e.target.value);
          setUpdateFlag(true);
        }
     
      }
      label="Payment Mode" // Important for proper floating label
    >
      <MenuItem value={constants.PAYMENT_MODE.CASH}>Cash</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.CARD}>Card</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.BANKTRANSFER}>Bank Transfer</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.PAYPAL}>Paypal</MenuItem>
    </Select>
    </FormControl>
    <FormControl  variant="outlined" size="small"   sx={{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2, // space between label and radios
    minWidth: 150
  }}>
      <FormLabel id='paymentstatus-label'>Status : </FormLabel>
      <RadioGroup
        row
        name="paymentstatus"
        labelId="paymentstatus-label"
        value={paymentstatus}
        onChange={(e) =>
    {
      setPaymentstatus(e.target.value);
      setUpdateFlag(true);
    }
        }
      >
        <FormControlLabel value={constants.PAYMENT_STATUS.PENDING} control={<Radio />} label="Pending" />
        <FormControlLabel value={constants.PAYMENT_STATUS.PAID} control={<Radio />} label="Paid" />
      </RadioGroup>
    </FormControl>
    {
      updateFlag &&
      <Button onClick={updateOrder} variant='contained'>Update</Button>
    }


</Stack>
</Stack>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Product Code</TableCell>
                  <TableCell>Product Name</TableCell>
                  <TableCell>Box number</TableCell>
                  <TableCell>Barcode</TableCell>
                  <TableCell sx={{ textAlign: 'right' }}>Unit Price</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell sx={{ textAlign: 'right' }}>Line Item Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order.order_details?.map((item, idx) => (
                  <TableRow key={idx}>
                    <TableCell  sx={{ width: 100 }}>{item.productcode}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.boxnumber}</TableCell>
                    <TableCell>{item.barcode}</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>€ {item.unitprice}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>€ {item.lineitemprice}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </DialogContent>

      <DialogActions>
      { (order)?
        <Tooltip title={copied ? 'Copied!' : 'Copy invoice link'}>
  <button
    onClick={() => handleCopy(order.order_id, order.hashedvalue)}
    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
    aria-label="Copy download link"
>
    <ContentCopyIcon />
  </button>
</Tooltip>

:null}
        <Button onClick={onClose} color="secondary">Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default OrderDetailsPopup;
